<script lang="ts">
  import { onMount } from 'svelte'
  import { useParams, Link } from 'svelte-navigator'
  import { writable } from 'svelte/store'
  import Modal from 'svelte-simple-modal'
  import { shuffle } from 'lodash-es'

  import { UserData, userAnswers, usersAnswers } from '../api/api'
  import { ROUTES } from '../constants/constants'
  import { surveyStatus, modalAnswerList, modalUserId } from '../stores'
  import FinalRecap from './FinalRecap.svelte'
  import DropdownMenu from './DropdownMenu.svelte'
  import DataPortrait from './DataPortrait.svelte'

  const params = useParams()
  let dataWallDataset: UserData[] = []
  let dataWallCount: number = null

  onMount(async () => {
    if ($params.userId) {
      $surveyStatus.userAnswersList = Object.values(await userAnswers($params.userId))
      $surveyStatus = $surveyStatus
      $modalUserId = $params.userId
      finalModal.set(FinalRecap)
    }
  })

  onMount(async () => {
    const { data, count } = await usersAnswers([0, 20])
    dataWallDataset = shuffle(data)
    dataWallCount = count
  })

  let finalModal = writable(null)
  let innerWidth = window.innerWidth
</script>

<svelte:window bind:innerWidth />

<Modal
  show={$finalModal}
  styleContent={{ padding: '0' }}
  styleCloseButton={{ boxShadow: 'none', background: '#e4e4e4' }}
  styleWindow={{ overflow: 'hidden' }}
/>

<DropdownMenu selected="Ritratti di mobilità" />

<div class="container">
  <div class="portrait-wrapper">
    {#if $surveyStatus.userAnswersList.length > 0}
      <DataPortrait width={75 * 2.5} answerList={$surveyStatus.userAnswersList} />

      <svg
        on:click={() => {
          $modalUserId = $params.userId
          finalModal.set(FinalRecap)
        }}
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" rx="15" fill="white" />
        <path
          d="M9.1668 16.9445C8.63208 16.9445 8.19458 17.382 8.19458 17.9167V20.8333C8.19458 21.3681 8.63208 21.8056 9.1668 21.8056H12.0835C12.6182 21.8056 13.0557 21.3681 13.0557 20.8333C13.0557 20.2986 12.6182 19.8611 12.0835 19.8611H10.139V17.9167C10.139 17.382 9.70152 16.9445 9.1668 16.9445ZM9.1668 13.0556C9.70152 13.0556 10.139 12.6181 10.139 12.0833V10.1389H12.0835C12.6182 10.1389 13.0557 9.7014 13.0557 9.16668C13.0557 8.63196 12.6182 8.19446 12.0835 8.19446H9.1668C8.63208 8.19446 8.19458 8.63196 8.19458 9.16668V12.0833C8.19458 12.6181 8.63208 13.0556 9.1668 13.0556ZM19.8612 19.8611H17.9168C17.3821 19.8611 16.9446 20.2986 16.9446 20.8333C16.9446 21.3681 17.3821 21.8056 17.9168 21.8056H20.8335C21.3682 21.8056 21.8057 21.3681 21.8057 20.8333V17.9167C21.8057 17.382 21.3682 16.9445 20.8335 16.9445C20.2987 16.9445 19.8612 17.382 19.8612 17.9167V19.8611ZM16.9446 9.16668C16.9446 9.7014 17.3821 10.1389 17.9168 10.1389H19.8612V12.0833C19.8612 12.6181 20.2987 13.0556 20.8335 13.0556C21.3682 13.0556 21.8057 12.6181 21.8057 12.0833V9.16668C21.8057 8.63196 21.3682 8.19446 20.8335 8.19446H17.9168C17.3821 8.19446 16.9446 8.63196 16.9446 9.16668Z"
          fill="black"
        />
      </svg>
    {/if}

    <div class="tot-sondaggi">
      <span class="total">{dataWallCount || ''}</span>
      <h3>Cittadini sondaggiati</h3>
    </div>
  </div>

  <div class="data-wall" style={`width: ${innerWidth}`}>
    {#each dataWallDataset as userSurvey}
      <div class="portrait-square">
        <button
          class="modal-opener"
          on:click={() => {
            $modalUserId = userSurvey.user_id
            $modalAnswerList = Object.values(userSurvey.answers)
            finalModal.set(FinalRecap)
          }}
        />
        <div class="content">
          <DataPortrait width={innerWidth / 5} answerList={Object.values(userSurvey.answers)} />
        </div>
      </div>
    {/each}
  </div>

  {#if $surveyStatus.userAnswersList.length === 0}
    <Link to={`../${ROUTES.survey}`}>
      <button class="go-to-survey"
        >Partecipa al sondaggio<span
          ><svg
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.475 2C17.475 1.26225 16.8769 0.664189 16.1392 0.664189L4.11689 0.664189C3.37914 0.664189 2.78108 1.26225 2.78108 2C2.78108 2.73775 3.37914 3.33581 4.11689 3.33581L14.8034 3.33581V14.0223C14.8034 14.76 15.4014 15.3581 16.1392 15.3581C16.8769 15.3581 17.475 14.76 17.475 14.0223V2ZM1.94456 18.0837L17.0837 2.94456L15.1946 1.05544L0.0554392 16.1946L1.94456 18.0837Z"
              fill="black"
            />
          </svg>
        </span>
      </button></Link
    >
  {/if}
</div>

<style>
  .container {
    width: 100%;
    overflow: hidden;
  }

  .portrait-wrapper {
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  .portrait-wrapper svg {
    position: absolute;
    top: 245px;
    transform: translateX(65px);
    cursor: pointer;
  }

  .tot-sondaggi {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .total {
    font-size: 34px;
    font-weight: 600;
  }

  h3 {
    font-size: 14px;
    margin: 0.5rem 0;
  }

  .data-wall {
    width: 100%;
  }

  .portrait-square {
    float: left;
    position: relative;
    width: 20%;
    padding-bottom: 20%; /* = width for a 1:1 aspect ratio */
    margin: 0;
    background-color: #1e1e1e;
    cursor: pointer;
  }
  .portrait-square button {
    appearance: none;
    border: 0;
    margin: 0;
    background-color: transparent;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 2;
    cursor: pointer;
  }
  .portrait-square .content {
    position: absolute;
    height: 100%; /* = 100% - 2*10% padding */
    width: 100%; /* = 100% - 2*5% padding */
    padding: 0;
  }

  button.go-to-survey {
    z-index: 2;
    cursor: pointer;
    height: 60px;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    border: none;
    border-radius: 0;
    padding: 1.2rem 1.5rem;
    margin: 0;
    color: black;
    font-weight: 700;
    font-size: 20px;
    background-color: #00fff0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  button.go-to-survey span {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 1.2rem 1.5rem;
    display: flex;
    align-items: center;
  }
</style>
